<template>
    <div style="padding: 20px">

        <div class="tip">
          <p>对订单进行分组管理，可实现不同订单按照不同规则自动审核和不同订单分配不同仓库。</p>
        </div>

        <!--按钮-->
        <div>
            <el-button class="mybtn-blue2" style="width: 100px" @click="showAddDialog()">新增</el-button>
        </div>

        <!--标题-->
        <div class="config-title">订单分组</div>

        <!--表格-->
        <el-table :data="main$data" v-loading="main$loading" size="medium">
            <el-table-column type="index" label="序号" width="50" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="name" label="分组名称" width="180" align="center" header-align="center"></el-table-column>
            <el-table-column prop="app" label="用途" width="220" align="center" header-align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.app == '1'">审核</span>
                    <span v-else-if="scope.row.app == '2'">仓库分配</span>
                    <span v-else-if="scope.row.app == '3'">全部</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="说明" width="260" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="states" label="状态" width="100" align="center" header-align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.states == '0'">停用</span>
                    <span v-else-if="scope.row.states == '1'" style="color: #29CF87">启用</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" header-align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="table_update(scope.row)">修改</el-button>
                    <el-button type="text" @click="table_delete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--dialog 新增、编辑-->
        <el-dialog :title="editDialogType=='add'?'新增订单分组':'编辑订单分组'"
                   :visible.sync="editDialogVisible"
                   class="mydialog mydialog_add_order_group"
                   :append-to-body="true">
            <el-form :label-position="'right'" label-width="90px" class="myform">
                <input type="hidden" v-model="editData.id">
                <!---->
                <el-form-item label="分组名称：">
                    <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.name"></el-input>
                </el-form-item>
                <!---->
                <el-form-item label="用途：">
                  <el-radio-group v-model="editData.app">
                    <el-radio label="1">审核</el-radio>
                    <!--<el-radio label="2">仓库分配</el-radio>-->
                    <!--<el-radio label="3">全部</el-radio>-->
                  </el-radio-group>
                </el-form-item>
                <!---->
                <el-form-item label="分组规则：">
                  <div class="dg-desc">设置多条分组规则时，需同时满足设置的条件，分组规则才生效。</div>
                  <el-select size="small" value="选择规则" v-model="editData.OrderGropuType" @change="selectRule">
                    <el-option v-for="(item,item_idx) in data_OrderGropuType" :key="item_idx"
                               :label="item.value" :value="item.code"></el-option>
                  </el-select>
                  <!----------------规则 START---------------->
                  <div v-for="(item,item_idx) in data_OrderGropuType" :key="item_idx">
                      <div v-if="item.code=='01'">
                          <!--按数据来源-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <el-checkbox-group v-model="editData['r_val_'+item.code]">
                              <el-checkbox class="my-checkbox" v-for="(item,item_idx) in data_dataSource" :key="item_idx"
                                           :label="item.code">{{item.value}}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                      </div>
                      <div v-else-if="item.code=='02'">
                          <!--按客户分类-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <el-checkbox-group v-model="editData['r_val_'+item.code]">
                              <el-checkbox class="my-checkbox" v-for="(item,index) in data_customerType" :key="index"
                                           :label="item.vipStar">{{item.vipName}}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                      </div>
                      <div v-else-if="item.code=='03'">
                          <!--按支付方式-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <el-checkbox-group v-model="editData['r_val_'+item.code]">
                              <el-checkbox  class="my-checkbox" v-for="(item,index) in data_payType" :key="index"
                                            :label="item.typeId">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                      </div>
                      <div v-else-if="item.code=='04'">
                          <!--按收货地址-->
                          <div v-if="editData['r_show_'+item.code]" style="margin-bottom: 15px">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <div>
                              <el-input placeholder="请输入内容" v-model="editData['r_val_'+item.code]"></el-input>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="item.code=='05'">
                          <!--按订单金额-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <div style="margin-bottom: 5px">
                                <table>
                                    <tr>
                                        <td style="line-height: normal;color: #999">订单金额下限</td>
                                        <td></td>
                                        <td style="line-height: normal;color: #999">订单金额上限</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <el-input size="small" placeholder="输入金额,如0" style="width: 130px" v-model="editData['r_val_min_'+item.code]"></el-input>
                                        </td>
                                        <td>
                                            -
                                        </td>
                                        <td>
                                            <el-input size="small" placeholder="输入金额,如0" style="width: 130px" v-model="editData['r_val_max_'+item.code]"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="item.code=='06'">
                          <!--按商品数量-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <div style="margin-bottom: 5px">
                                <table>
                                    <tr>
                                        <td style="line-height: normal;color: #999">商品数量下限</td>
                                        <td></td>
                                        <td style="line-height: normal;color: #999">商品数量上限</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <el-input size="small" placeholder="输入数量,如0" style="width: 130px" v-model="editData['r_val_min_'+item.code]"></el-input>
                                        </td>
                                        <td>
                                            -
                                        </td>
                                        <td>
                                            <el-input size="small" placeholder="输入数量,如0" style="width: 130px" v-model="editData['r_val_max_'+item.code]"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="item.code=='07'">
                          <!--按商品类别-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <el-checkbox-group v-model="editData['r_val_'+item.code]">
                              <el-checkbox  class="my-checkbox" v-for="(item,index) in data_goodsCategory" :key="index"
                                            :label="item.catId">{{item.catName}}</el-checkbox>
                            </el-checkbox-group>
                          </div>
                      </div>
                      <div v-else>
                          <!--其他-->
                          <div v-if="editData['r_show_'+item.code]">
                            <span class="subtitle">{{item.value}}</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                            <div>
                              <el-input placeholder="请输入内容" v-model="editData['r_val_'+item.code]"></el-input>
                            </div>
                          </div>
                      </div>
                  </div>
                  <!----------------规则 END---------------->
                </el-form-item>
                <!---->
                <el-form-item label="权重：">
                    <el-input size="small" placeholder="请输入" class="dg-input"  v-model="editData.weight"></el-input>
                    <div class="dg-desc">填写数字越大，代表权重越高，优先级越高</div>
                </el-form-item>
                <!---->
                <el-form-item label="描述：">
                    <el-input size="small" type="textarea" placeholder="请填写对订单的简要描述"  v-model="editData.description"></el-input>
                </el-form-item>
                <!---->
                <el-form-item label="状态：">
                  <el-radio-group v-model="editData.states">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="mybtn-blue2" @click="saveDialogData">保存</el-button>
                <el-button @click="editDialogVisible=false">取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格
            main$loading: false,
            main$data: [],
            // 下拉框等数据
            data_OrderGropuType:[],
            data_dataSource:[],
            data_customerType:[],
            data_payType:[],
            data_goodsCategory:[],
            // 新增、编辑对话框
            editDialogVisible:false,
            editDialogType:'',
            editData:{ }
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/rule/ordergroup/getList'), {

            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$data = [];
                }
                else {
                    self.main$data = res.data.data;
                }
            });
        },
        table_update: function (row) {
            let self = this;

            self.xEui.myloading('加载中...')
            self.xFetch.post(self.xApi('/robot/rule/ordergroup/getDetails'), {
                id:row.id
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let obj = res.data.data;
                let editData = self.getDefaultEditData();

                editData.id = obj.id;
                editData.name = obj.name;
                editData.app = obj.app + '';
                editData.weight = obj.weight;
                editData.description = obj.description;
                editData.states = obj.states + '';

                obj.ruleList.forEach(function(rule){
                    let code = rule.type;

                    // 显示
                    editData['r_show_'+code]=true;

                    // 值
                    if (code == '01' || code == '02' || code == '03' || code == '07') {
                        editData['r_val_' + code] = (rule.content || '').split(',')
                    }
                    else {
                        editData['r_val_' + code] = rule.content;
                        if (rule.hasOwnProperty('rangeUp')) {
                            editData['r_val_min_' + code] = rule.rangeUp;
                            editData['r_val_max_' + code] = rule.rangeDown;
                        }
                    }
                });

                // show dialog
                self.editDialogVisible = true;
                self.editDialogType = 'update';
                self.editData = editData;
            });
        },
        table_delete: function (row) {
            let self = this;
            self.xEui.confirm('','确认要删除该条记录吗？',function(){
                self.xEui.myloading('删除中...')
                self.xFetch.post(self.xApi('/robot/rule/ordergroup/delete'), {
                    id:row.id
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close();

                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    else{
                        self.xEui.msg_success('删除成功')
                        self.fetchData();
                    }
                });
            })
        },
        getDefaultEditData: function(){
            let self = this;
            let editData = {
                app:'1',
                states:'1'
            };
            self.data_OrderGropuType.forEach(function(item){
                if(item.code == '01'
                    ||item.code == '02'
                    ||item.code == '03'
                    ||item.code == '07'){
                    // checkbox多选
                    editData['r_val_'+item.code]=[];
                }
            });
            return editData;
        },
        showAddDialog: function(){
            this.editDialogVisible = true;
            this.editDialogType = 'add';
            this.editData = this.getDefaultEditData();
        },
        selectRule: function(){
            let code = this.editData.OrderGropuType;
            if(code){
                this.$set(this.editData, 'r_show_' + code, true)
            }
        },
        removeRule: function(code){
            this.$set(this.editData, 'r_show_' + code, false)
        },
        saveDialogData: function(){
            let self = this;
            let postData = {
                'id':self.editData.id,
                'name':self.editData.name,
                'app':self.editData.app,
                'weight':self.editData.weight,
                'description':self.editData.description,
                'states':self.editData.states,
                'ruleList':[]
            }
            for (let p in self.editData) {
                if (p.indexOf('r_show_') >= 0 && self.editData[p]) {
                    let code = p.replace('r_show_', '');
                    postData.ruleList.push({
                        "type": code,
                        "rangeUp": self.editData['r_val_min_' + code] ? self.editData['r_val_min_' + code] : 0,
                        "rangeDown": self.editData['r_val_max_' + code] ? self.editData['r_val_max_' + code] : 0,
                        "content": self.editData['r_val_'+code]
                                        ? (self.editData['r_val_'+code].join
                                                ?self.editData['r_val_'+code].join(',')
                                                :self.editData['r_val_'+code]
                                            )
                                        : ''
                    });
                }
            }

            if(!postData.name){
                self.xEui.msg_error('请输入分组名称')
                return;
            }

            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi(
                    postData.id ? '/robot/rule/ordergroup/update' : '/robot/rule/ordergroup/add'
            ), postData).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.editDialogVisible = false;
                    self.fetchData();
                }
            });
        }
    },
    created: function () {
        let self = this;

        // 表格数据
        self.fetchData();

        // 下拉框等数据
        //--订单分组规则
        self.xFetch.post(self.xApi('/robot/common/getOrderGropuType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }

            self.data_OrderGropuType = res.data.data;
        });
        //--数据来源
        self.xFetch.post(self.xApi('/robot/common/getDataSource'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_dataSource = res.data.data;
        });
        //--客户分类
        let user = localStorage.getItem('sysale-robot$user');
        user = JSON.parse(user);
        self.xFetch.post(self.xApi('/xx_admin/customer.CustVipdefMgr/getValidCustVipdef?sessionid='+user.data.sessionid)).then(function (res) {
  //            console.log(res)
          if(res.data.ret_status='ok'){
            for(let i of res.data.vipdefList){
              i.vipStar=i.vipStar+'';
            }
            self.data_customerType = res.data.vipdefList;
          }else {
            self.xEui.msg_error(res.data.rpc_msg);
          }
        });
//        self.xFetch.post(self.xApi('/robot/common/getCustomerType'), {}).then(function (res) {
//            if (res.data.code != '00') {
//                self.xEui.msg_error(res.data.text)
//                return
//            }
//            self.data_customerType = res.data.data;
//        });
        //--支付方式
        self.xFetch.post(self.xApi('/robot/common/getPayType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_payType = res.data.data;
        });
        //--商品类别
        self.xFetch.post(self.xApi('/robot/common/getCategory'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_goodsCategory = res.data.data;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-input, .el-select, .el-date-editor.el-input{
      width: 220px;
    }
    .el-textarea{
      width: 370px;
    }
    .my-checkbox{
        margin: 0;
        margin-right: 30px;
    }
    /*config-title*/
    .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
    /*mydialog_add_order_group*/
    .mydialog_add_order_group{ }
    .mydialog_add_order_group .dg-input{ width: 220px }
    .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399; }
    p{
      margin: 0;
    }
    .subtitle{
      font-size: 15px;
      font-weight: bold;
      margin-right: 20px;
    }
</style>
<style>
    /*mydialog_add_order_group*/
    .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
    .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/order-group.vue